"use client";

import { setTimeOffset } from "@website/utils/time-sync-utils";
import { useEffect } from "react";

const TimeSyncInitializer = ({ serverNow }: { serverNow: number }) => {
  useEffect(() => {
    const clientMs = Date.now();
    const diff = serverNow - clientMs;
    //ignore offset less than 10 min
    const offset = Math.abs(diff) > 60 * 1000 * 10 ? diff : 0;
    setTimeOffset(offset);
  }, [serverNow]);
  return null;
};
export default TimeSyncInitializer;
